import config from '@/config/config'
import axios from 'axios'

export default {
    state: {
        book: [],
        groups: [],
        groupMembership: [],
        pendingActions: [],
        pendingDetails: null,
        loadingBook: true,
        loadingGroup: true
    },
    mutations: {
        setBookOfBusiness (state, payload) {
            state.book = payload
        },
        setProducerGroups (state, payload) {
            state.groups = payload
        },
        setProducerGroupMembership (state, payload) {
            state.groupMembership = payload
        },
        setPendingActions (state, payload) {
            state.pendingActions = payload
        },
        setPendingDetails (state, payload) {
            state.pendingDetails = payload
        },
        setLoadingBook (state, payload) {
            state.loadingBook = payload
        },
        setLoadingGroup (state, payload) {
            state.loadingGroup = payload
        }
    },
    getters: {
        producerBook: state => state.book,
        producerGroup: state => state.groups,
        producerGroupMembership: state => state.groupMembership,
        pendingActions: state => state.pendingActions,
        pendingDetails: state => state.pendingDetails,
        loadingBook: state => state.loadingBook,
        loadingGroup: state => state.loadingGroup
    },
    actions: {
        getProducerBook ({commit}) {
            commit('setBookOfBusiness', [])
            commit('setLoadingBook', true)
            axios.get(config.apiUrl() + 'producer/getBook').then(response => {
                commit('setBookOfBusiness', response.data)
                commit('setLoadingBook', false)
            }, err => {
                commit('setBookOfBusiness', [])
                commit('setLoadingBook', false)
            })
        },
        getProducerGroups ({commit}) {
            commit('setProducerGroups', [])
            commit('setLoadingGroup', true)
            axios.get(config.apiUrl() + 'producer/getGroup').then(response => {
                commit('setProducerGroups', response.data)
                commit('setLoadingGroup', false)
            }, err => {
                commit('setProducerGroups', [])
                commit('setLoadingGroup', false)
            })
        },
        getProducerGroupMembership ({commit}, group) {
            commit('setProducerGroupMembership', null)
            axios.get(config.apiUrl() + 'producer/getGroup/' + group + '/membership').then(response => {
                commit('setProducerGroupMembership', response.data)
            }, err => {
                commit('setProducerGroupMembership', [])
            })
        },
        getPendingActions ({commit}) {
            commit('setPendingActions', [])
            axios.get(config.apiUrl() + 'user/pending-actions').then(response => {
                commit('setPendingActions', response.data)
            }, err => {
                commit('setPendingActions', [])
            })
        },
        getPendingDetails ({commit}, id) {
            commit('setPendingDetails', null)
            axios.get(config.apiUrl() + 'user/pending-actions/' + id).then(response => {
                commit('setPendingDetails', response.data)
            }, err => {
                commit('setPendingDetails', null)
            })
            // commit('setPendingDetails', JSON.parse('{"id":"470","user_id":null,"producer_id":"3","group_code":"001GYI","cert":"","date_recieved":"2020-09-11 11:11:23","date_accepted":null,"date_completed":null,"request_type":"new_enrollment","effective_date":"2020-06-01","original_record":null,"change_requested":{"children":[{"firstName":"Derek","lastName":"Thomas","dob":"2020-09-16","gender":"F","type":"child","cov":"N"}],"firstName":"Test","middleInitial":"","lastName":"Thomas","gender":"F","ssn":"Redacted","dob":"2020-09-02","groupUnderwriter":"","groupCode":"001GYI","planSelection":{"DE":{"plan":"001GYIMA","tier":"C"},"DL":[],"VL":[],"VC":[],"VD":[],"LA":[],"VI":{"plan":"001VISP","tier":"E"},"WI":[],"CI":[],"DI":[],"LT":[]},"tierSelection":"","effectiveDate":"2020-06","middleName":"","address":"2641 W Divide Creek St","address2":"","city":"Meridian","stateName":"ID","zipCode":"83646-","homePhone":"2088302960","workPhone":"","dhmoId":"","hoursWorked":"40","dateHired":"2020-09-16","otherCarrier":"","complete":false,"step":"products","errors":[],"action":"new_enrollment","email":"dthomas@galaxisweb.com"},"orginal_record":null}'))
        },
        updateProducerInfo ({commit, dispatch}, data) {
            axios.post(config.apiUrl() + 'producer/update', data).then(response => {
                dispatch('')
            }, err => {
                commit('setProducerGroupMembership', [])
            })
        }
    }
}
